import {
  CHANGE_INPUT,
  CHANGE_STEP,
  CHECK_BIOMETRICS_AND_PIN_INFO,
  DISABLE_ALT_AUTH_METHODS,
  DISABLE_BIOMETRIC_LOGIN,
  DISABLE_BIOMETRIC_LOGIN_FAILURE,
  DISABLE_BIOMETRIC_LOGIN_SUCCESS,
  DISABLE_PIN,
  DISABLE_PIN_FAILURE,
  DISABLE_PIN_SUCCESS,
  ENABLE_BIOMETRIC_LOGIN,
  ENABLE_BIOMETRIC_LOGIN_FAILURE,
  ENABLE_BIOMETRIC_LOGIN_SUCCESS,
  FOCUS_INPUT,
  RESET_DRAWER_INPUTS_AND_ERRORS,
  RESET_STATE,
  SET_PIN,
  SET_PIN_FAILURE,
  SET_PIN_SUCCESS,
  UPDATE_BIOMETRICS_AND_PIN_INFO,
  UPDATE_ERROR,
} from './constants';

export function changeInput({ field, value }) {
  return {
    payload: { field, value },
    type: CHANGE_INPUT,
  };
}

export function changeStep({ step }) {
  return {
    payload: { step },
    type: CHANGE_STEP,
  };
}

export function checkBiometricsAndPinInfo() {
  return { type: CHECK_BIOMETRICS_AND_PIN_INFO };
}

export function disableAltAuthMethods() {
  return { type: DISABLE_ALT_AUTH_METHODS };
}

export function disableBiometricLogin() {
  return { type: DISABLE_BIOMETRIC_LOGIN };
}

export function disableBiometricLoginFailure({ error }) {
  return {
    payload: { error },
    type: DISABLE_BIOMETRIC_LOGIN_FAILURE,
  };
}

export function disableBiometricLoginSuccess() {
  return { type: DISABLE_BIOMETRIC_LOGIN_SUCCESS };
}

export function disablePin() {
  return { type: DISABLE_PIN };
}

export function disablePinFailure({ error }) {
  return {
    payload: { error },
    type: DISABLE_PIN_FAILURE,
  };
}

export function disablePinSuccess() {
  return { type: DISABLE_PIN_SUCCESS };
}

export function enableBiometricLogin() {
  return { type: ENABLE_BIOMETRIC_LOGIN };
}

export function enableBiometricLoginFailure({ error }) {
  return {
    payload: { error },
    type: ENABLE_BIOMETRIC_LOGIN_FAILURE,
  };
}

export function enableBiometricLoginSuccess() {
  return { type: ENABLE_BIOMETRIC_LOGIN_SUCCESS };
}

export function focusInput({ field }) {
  return {
    payload: { field },
    type: FOCUS_INPUT,
  };
}

export function resetDrawerInputsAndErrors() {
  return { type: RESET_DRAWER_INPUTS_AND_ERRORS };
}

export function resetState() {
  return { type: RESET_STATE };
}

export function setPin({ pin }) {
  return {
    payload: { pin },
    type: SET_PIN,
  };
}

export function setPinFailure({ error }) {
  return {
    payload: { error },
    type: SET_PIN_FAILURE,
  };
}

export function setPinSuccess() {
  return { type: SET_PIN_SUCCESS };
}

export function updateBiometricsAndPinInfo({
  isBiometricLoginEnabled,
  isPinEnabled,
  supportedBiometricAuthenticationTypes,
}) {
  return {
    payload: {
      isBiometricLoginEnabled,
      isPinEnabled,
      supportedBiometricAuthenticationTypes,
    },
    type: UPDATE_BIOMETRICS_AND_PIN_INFO,
  };
}

export function updateError({ subType, type, value }) {
  return {
    payload: { subType, type, value },
    type: UPDATE_ERROR,
  };
}
